<template>
      <div class="container-fluid">
        <div class="row ">
            <div class="col-md-5 signin_background_color ">
                <div class="mx-auto margin-top-130 padding-left-130">
                    <a href="https://symlexlayer.com"> <img src="assets/image/logo/logo_white.svg" alt="logo" class="img-fluid"></a>
                </div>
                <div class="mx-auto padding-left-130 mt-5">
                    <h1 class="sign_text text-left">
                        Confirm Your Business Security
                    </h1>
                    <p class="sign_sub_text mt-3">
                        Just 3 easy step to sign up
                    </p>
                </div>
                <div class="mt-5">
                    <img src="assets/image/signin_background.svg" alt="backround" class="img-fluid mt-5">
                </div>
            </div>
           <router-view/>
        </div>
    </div>
</template>

<script>
export default {
  name: "guest-layouts",
};
</script>

<style scoped></style>
